import { useMutation } from 'react-query'
import { axiosInstanceIservices } from 'lib/services/config/axios-config'
import { useAuth0 } from 'app/Auth'
import {
  SendPreviewSurgeryReportResponse,
  SendPreviewSurgeryReportInput,
} from './types'

const sendPreviewSurgeryReport = async (
  input: SendPreviewSurgeryReportInput,
  token: string
): Promise<SendPreviewSurgeryReportResponse> => {
  const response =
    await axiosInstanceIservices.post<SendPreviewSurgeryReportResponse>(
      '/surgery-report-templates/send-preview-surgery-report',
      input,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
  return response.data
}

export const useSendAndPreviewSurgeryReport = () => {
  const { getAccessToken } = useAuth0()

  return useMutation<
    SendPreviewSurgeryReportResponse,
    Error,
    SendPreviewSurgeryReportInput
  >(
    async (input: SendPreviewSurgeryReportInput) => {
      const token = await getAccessToken()
      return sendPreviewSurgeryReport(input, token)
    },
    {
      onSuccess: () => {},
      onError: () => {},
    }
  )
}

export type {
  SendPreviewSurgeryReportResponse,
  SendPreviewSurgeryReportInput,
  SendPreviewSurgeryReportAttachment,
} from './types'
